import actionTypes from '../../constants/actions/importarPedidosExcel/importarPedidosExcel'

export function initialState () {
  return {
    showModalImportarPedidosExcel: false,
    archivoExcel: [],
    listImportarPedidosExcel: []
  }
}

export function abrirModalImportarPedidosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarPedidosExcel: true
  }
}

export function cerrarModalImportarPedidosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarPedidosExcel: false,
    archivoExcel: [],
    listImportarPedidosExcel: []
  }
}

export function subirArchivosImportarPedidosExcel (state, {archivoExcel}) {
  return {
    ...state,
    archivoExcel: archivoExcel
  }
}

export function submitImportarPedidosExcelSuccess (state, {listImportarPedidosExcel}) {
  return {
    ...state,
    listImportarPedidosExcel: listImportarPedidosExcel
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.ABRIR_MODAL_IMPORTAR_PEDIDOS_EXCEL:
      return abrirModalImportarPedidosExcel(state, action)
     case actionTypes.CERRAR_MODAL_IMPORTAR_PEDIDOS_EXCEL:
      return cerrarModalImportarPedidosExcel(state, action)
     case actionTypes.SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS_EXCEL:
      return subirArchivosImportarPedidosExcel(state, action)
     case actionTypes.SUBMIT_IMPORTAR_PEDIDOS_EXCEL_SUCCESS:
      return submitImportarPedidosExcelSuccess(state, action)
    default:
      return state
  }
}
